import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import useThrottleClick from 'hooks/useThrottleClick';
import Button, { ButtonColors } from 'components/button';
import { openStore, trackEvent } from 'utils';
import './styles.scss';

interface IInstallButton {
  gameId: string;
  trackClickURL: string;
  inAppPurchase?: boolean;
  className?: string;
}

const InstallButton: React.FC<IInstallButton> = ({
  gameId,
  trackClickURL,
  className,
  inAppPurchase = false,
}) => {
  const { t } = useTranslation();

  const handleClick = useThrottleClick(undefined, undefined, async () => {
    await trackEvent(trackClickURL);

    openStore(gameId);
  }, 3000);

  return (
    <Button
      title={t('getButton')}
      className={`install-btn ${className ?? ''}`}
      color={ButtonColors.blue}
      description={inAppPurchase ? 'In-App Purchase' : undefined}
      onClick={handleClick}
    />
  );
};

export default memo(InstallButton);
